import { useGetRemoteLockConnection } from './get-remote-lock-connection'

// Note: shared by every surface that needs to know whether a building's Remote Lock
// integration is actually usable right now — Places → Integrations (the connection status
// pill) and the resident profile's Keyless Access tab (both designs), which used to trust a
// static `remoteLockAvailable` building flag with no live check at all. Unlike Salto Space,
// Remote Lock's connection endpoint reads only our own DB (no separate live vendor probe), so
// `isSuccess` alone is the same signal `use-remote-lock-connection.ts` already uses on the
// Places page.
export const useIsRemoteLockBuildingConnected = (buildingId: number) => {
  const { isLoading, isSuccess } = useGetRemoteLockConnection({ buildingId })

  return {
    isBuildingConnected: isSuccess,
    isLoading,
  }
}
